
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./moly-icons.cjs.production.min.js')
} else {
  module.exports = require('./moly-icons.cjs.development.js')
}
